import BackgroundElement from './BackgroundElement';
import BackgroundElementPresets from './BackgroundElementPresets';
import BackgroundElementMetaData from './BackgroundElementMetaData';
import BackgroundElementProps from './BackgroundElementProps';

export default {
  metaData: BackgroundElementMetaData,
  elementClass: BackgroundElement,
  elementProps: BackgroundElementProps,
  presets: BackgroundElementPresets
};
